import {TabState, TabStateDefaults} from 'Navigation';

export default class GridContentsTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Contents',
      closeable: false,
      preferenceKey: 'grid-contents',
    };
  }
}
